<div #draggableDiv class="draggable-div" (mousedown)="startDragging($event)" [style.left.px]="position.x"
    [style.top.px]="position.y">
    <div class="drag-handle">{{"Media Buttons" | translate}}</div>
    <div class="content">
        <div _ngcontent-ng-c1826359624="" class="vidiobutton"
            style="display: flex; border: 1px solid #c3b8b8; border-radius: 10px;">
            <button id="Start" type="button" class="btn btn-outline-success btn-lg" title="Start"
                [disabled]="isButtonDisabled" (click)="StartRecord()">
                <i [ngClass]="iconClass"></i>
            </button>
            <button type="button" class="btn btn-outline-danger btn-lg" [title]="isPaused ? 'Resume' : 'Pause'"
                [disabled]="isPauseButtonDisabled" (click)="toggleRecord()">
                <i [class]="isPaused ? 'fa fa-play-circle' : 'fa fa-pause-circle'"></i>
            </button>
            <button (click)="StopRecord()" _ngcontent-ng-c1826359624="" type="button" title="Stop"
                [disabled]="StopRecordbutton" class="btn btn-outline-warning btn-lg">
                <i _ngcontent-ng-c1826359624="" class="fa fa-stop-circle"></i>
            </button>
        </div>
    </div>
</div>
<ng-template #start_session let-modal>
    <div class="modal-content">
        <div class="Screenrecord">
            <p class="alert-message" style="margin-top: 5px;text-align: center;">{{"Are you sure you want to Start Recording??" | translate}}
            </p>
        </div>
        <div class="modal-footer alert-actions">
            <button type="button" class="btn btn-success" (click)="StartRecordConfirm();">{{"Yes, Proceed" |
                translate}}</button>&nbsp;
            <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
                translate}}</button>&nbsp;
        </div>
    </div>
</ng-template>
<ng-template #stop_session let-modal>
    <div class="modal-body " style="text-align: center;">
        <p class="alert-message" style="overflow-wrap: break-word;">{{"Recording is Stopped!" | translate}}</p>
    </div>
    <div class="modal-footer alert-actions" style="justify-content: center;">
        <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
</ng-template>